<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="back-to-top-vector">
    <circle cx="9" cy="9" r="9" fill="black"/>
    <path d="M4.75 4.92578C4.75 4.92578 7.37836 4.92578 9.0625 4.92578C10.7466 4.92578 13.375 4.92578 13.375 4.92578" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6 12.9258L9 9.92578L12 12.9258" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
